var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasSsoEnabled)?_c('Container',{attrs:{"size":"narrow"}},[_c('SsoConfigurationForm')],1):_c('SsoForbidden')
}
var staticRenderFns = []

export { render, staticRenderFns }